<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="800">
    <v-form ref="form" class="px-11 py-10 white">
      <v-row class="pb-10">
        <v-col cols="11">
          <p class="form__title mb-0 gray--text">
            {{ title }}
          </p>
        </v-col>
        <v-col cols="1" class="text-end pb-5">
          <BaseButton text icon @click="closeModal" class="justify-end">
            <v-icon size="17" color="gray" class="justify-end">
              fa-times
            </v-icon>
          </BaseButton>
        </v-col>
        <v-col cols="12" class="py-5" v-if="isEdit">
          <v-switch
            v-model="form.ativo"
            class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
            inset
            dense
            hide-details
            color="secondary"
          />
          <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
            {{ statusSwitch(form.ativo) }}
          </p>
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5">
          <BaseFormInput
            id-element="nameCreditLineContact"
            placeholder="Digite"
            v-model="form.nome"
            required
            validate-on-blur
            :rules="[requiredInput]"
            label-text="Responsável Crédito"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <BaseFormInput
            id-element="emailCreditLineContact"
            placeholder="Digite"
            v-model="form.email"
            required
            validate-on-blur
            :rules="[requiredInput, isValidEmail]"
            label-text="E-mail"
            :upper-case="false"
          />
        </v-col>
        <v-col cols="12">
          <BaseFormInput
            id-element="departamentCreditLineContact"
            placeholder="Digite"
            v-model="form.departamento"
            required
            validate-on-blur
            :rules="[requiredInput]"
            label-text="Departamento / Cargo"
          />
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5">
          <BaseFormInput
            id-element="firstPhoneCreditLineContact"
            placeholder="Digite"
            v-model="form.telefone1"
            required
            validate-on-blur
            :rules="[requiredInput, isValidPhoneNumber]"
            v-facade="maskPhone"
            label-text="Comercial"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <BaseFormInput
            id-element="secondPhoneCreditLineContact"
            placeholder="Digite"
            v-model="form.telefone2"
            validate-on-blur
            :rules="[isValidPhoneNumber]"
            v-facade="maskPhone"
            label-text="Celular"
          />
        </v-col>
        <v-col cols="12">
          <v-switch
            v-model="form.solicitacao_via_portal"
            class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
            inset
            dense
            hide-details
            color="secondary"
          />
          <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
            Solicitação de Crédito através de portal
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="4" md="3">
          <BaseButton
            v-html="'ADICIONAR'"
            width="100%"
            class="secondary white--text"
            @click="submit"
          >
          </BaseButton>
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
import {
  requiredInput,
  isValidPhoneNumber,
  isValidEmail
} from "@/utils/rules.js";
import { maskPhone } from "@/utils/masks.js";
import { SwitchText } from "@/mixins/SwitchMixin.js";
import _ from "lodash";
export default {
  name: "NewContactModal",
  data: () => ({
    requiredInput,
    isValidPhoneNumber,
    maskPhone,
    isValidEmail,
    isEdit: false,
    form: {}
  }),
  mixins: [SwitchText],
  created() {
    this.isEdit = Boolean(this.item.nome);
    this.form = _.cloneDeep(this.item);
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    submit() {
      if (this.$refs.form.validate())
        this.$emit("submit", this.form, this.item);
    }
  },
  props: {
    title: {
      type: String
    },
    item: {
      type: Object
    }
  }
};
</script>
